import axios from 'axios'
import qs from 'qs'
import Cookies from 'js-cookie'
import Vue from 'vue'

import { Message } from 'element-ui'

const TOKEN_KEY = 'token'

const getToken = () => {
  const token = Cookies.get('tvToken') || Cookies.get(TOKEN_KEY)
  if (token && token !== 'undefined') {
    return token
  } else {
    return false
  }
}

export const baseURL = process.env.VUE_APP_BASEURL // api的base_url
// export const baseURL = process.env.NODE_ENV === 'development' ? 'http://tvtest-api.shenlakaoyan.com' : process.env.VUE_APP_BASEURL // api的base_url

/**
 * 创建axios实例
 * @type {AxiosInstance}
 */
const service = axios.create({
  baseURL,
  timeout: 30000 // 设置请求超时时间30s
})
/**
 * 请求参数处理
 */
service.interceptors.request.use((config) => {
  if (config.type && config.type === 'json') {
    // JSON格式传参
    config.method === 'post'
      ? config.data = JSON.stringify(config.data)
      : config.params = {
        ...config.params
      }
    config.headers['Content-Type'] = 'application/json;charset=UTF-8'
  } else if (!config.upload) {
    // formData格式传参
    config.method === 'post'
      ? config.data = qs.stringify({
        ...config.data
      })
      : config.params = {
        ...config.params
      }
  }
  const token = getToken()
  if (token && config.url.indexOf('openapi.baidu.com') < 0) {
    config.headers.Authorization = 'Bearer ' + token
  }
  return config
})
/**
 * 响应结果处理
 */
service.interceptors.response.use(
  (response) => {
    if (response.data.result) {
      return Promise.resolve(response.data)
    }
    if (response.data.code === 0) {
      // 服务端定义的响应code码为0时请求成功
      // 使用Promise.resolve 正常响应
      return Promise.resolve(response.data)
    }
    if (response.data.code === 1000) {
      // 服务端定义的响应code码为1000时请求成功
      // 使用Promise.resolve 正常响应
      return Promise.resolve(response.data)
    } else {
      // 使用Promise.reject 响应
      if (response.data.message) {
        Message.error({
          message: response.data.message
        })
      }
      return Promise.reject(response.data)
    }
  }, error => {
    let message = ''
    if (error && error.response) {
      switch (error.response.status) {
        case 401:
          (function () {
            const url = window.location.hostname
            const arr = url.split('.')
            let domain = ''
            if (arr.length > 2) {
              domain = arr.slice(arr.length - 2).join('.')
            } else {
              domain = arr.join('.')
            }
            Cookies.remove('tvToken', {
              domain: `${process.env.NODE_ENV === 'development' ? domain : '.' + domain
                }`
            })
            Cookies.remove('token')
            location.reload()
          })()
          return
        case 403:
          message = error.response.data.path + ',' + error.response.data.message
          break
        case 502:
          message = '连接服务器失败'
          break
        default:
          message = error.response.data.message ? error.response.data.message : '服务器错误'
          break
      }

      Message.error({
        content: message
      })
      // 请求错误处理
      return Promise.reject(error)
    } else {
      message = '连接服务器失败'
      Message.error({
        content: message
      })
      return Promise.reject(error)
    }
  }
)

export default service
